export default "__VITE_ASSET__kqxOBeft__"